import React, { Component } from 'react';
import { connect } from 'react-redux';
import './FormattedReportSelection.scss';

class FormattedReportSelection extends Component {

    mainMenuName = 'Formatted Report';

    constructor(props) {
        super(props);
        this.state = {
            expandedModules: {}
        };
    }

    toggleModule = (moduleName) => {
        this.setState(prev => ({
            expandedModules: {
                ...prev.expandedModules,
                [moduleName]: !prev.expandedModules[moduleName]
            }
        }));
    };

    getGroupedTiles = () => {
        const tiles = [
            { label: 'Daily Sales Report', to: '/formatted-daily-sales-report', icon: 'pi pi-fw pi-chart-line', module: 'Sales' },
            { label: 'Itemwise Sales Summary Report', to: '/formatted-itemwise-sales-summary-report', icon: 'pi pi-fw pi-list', module: 'Sales' },
            { label: 'Sales Report', to: '/formatted-sales-report', icon: 'pi pi-fw pi-shopping-cart', module: 'Sales' },
            { label: 'Cash Handover from Sales Report', to: '/formatted-cash-handover-from-sales-report', icon: 'pi pi-fw pi-money-bill', module: 'Cash' },
            { label: 'Cash Summary Report', to: '/formatted-cash-summary-report', icon: 'pi pi-fw pi-dollar', module: 'Cash' },
            { label: 'Employee Salary Report', to: '/formatted-employee-salary-report', icon: 'pi pi-fw pi-users', module: 'Human Resource' },
        ];

        // Group by module
        return tiles.reduce((groups, tile) => {
            const key = tile.module;
            if (!groups[key]) groups[key] = [];
            groups[key].push(tile);
            return groups;
        }, {});
    };

    handleTileClick = (tile) => {
        if (tile.to) {
            this.props.history.push(tile.to);
        }
    };

    render() {
        const grouped = this.getGroupedTiles();
        const moduleNames = Object.keys(grouped);
        const { expandedModules } = this.state;

        const moduleIcons = {
            'Sales':          'pi pi-fw pi-chart-line',
            'Cash':           'pi pi-fw pi-money-bill',
            'Human Resource': 'pi pi-fw pi-users',
        };

        return (
            <div className="p-grid formatted-report-selection">
                <div className="p-col-12">
                    <div className="card card-w-title">

                        <h1 className="formatted-report-selection__title">
                            <i className="pi pi-fw pi-file" />
                            {this.mainMenuName}
                        </h1>

                        {moduleNames.length === 0 ? (
                            <div className="formatted-report-selection__empty">
                                <i className="pi pi-lock" />
                                <p>No authorized pages found.</p>
                            </div>
                        ) : (
                            moduleNames.map((moduleName) => {
                                const isOpen = !!expandedModules[moduleName];
                                const tiles  = grouped[moduleName];

                                return (
                                    <div
                                        key={moduleName}
                                        className={`formatted-report-selection__panel ${isOpen ? 'formatted-report-selection__panel--open' : ''}`}
                                    >
                                        {/* Panel Header */}
                                        <div
                                            className="formatted-report-selection__panel-header"
                                            onClick={() => this.toggleModule(moduleName)}
                                        >
                                            <div className="formatted-report-selection__panel-header-left">
                                                <i className={moduleIcons[moduleName] || 'pi pi-fw pi-folder'} />
                                                <span>{moduleName}</span>
                                                <span className="p-badge">{tiles.length}</span>
                                            </div>
                                            <i className={`pi formatted-report-selection__panel-header-arrow ${isOpen ? 'pi-angle-up' : 'pi-angle-down'}`} />
                                        </div>

                                        {/* Panel Body */}
                                        {isOpen && (
                                            <div className="formatted-report-selection__panel-body">
                                                <div className="p-grid">
                                                    {tiles.map((tile, idx) => (
                                                        <div key={idx} className="p-col-12 p-md-4 p-lg-3">
                                                            <div
                                                                className="formatted-report-selection__tile"
                                                                onClick={() => this.handleTileClick(tile)}
                                                            >
                                                                <i className={tile.icon || 'pi pi-fw pi-file'} />
                                                                <span>{tile.label}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                );
                            })
                        )}

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    menuLists: state.auth.menuLists,
});

export default connect(mapStateToProps)(FormattedReportSelection);
